<div class="recipient-list-hint">
  <mat-icon class="recipient-list-hint__icon">info_outline</mat-icon>
  Drag recipients to change the signing order. Click any field to edit it.
</div>

<div cdkDropList class="recipient-list" (cdkDropListDropped)="drop($event)">
  <div *ngFor="let recipient of recipients; index as i" cdkDrag class="recipient-box">

    <!-- ROLE / ORDER COLUMN (drag handle) -->
    <div class="recipient-role" cdkDragHandle>
      <mat-icon class="recipient-role__grip">drag_indicator</mat-icon>
      <span class="recipient-role__order">{{ i + 1 }}</span>
      <div class="recipient-role__text">
        <span class="recipient-role__title">{{ recipient.role }}</span>
        <span class="recipient-role__name">
          {{ recipient.firstName?.value }} {{ recipient.lastName?.value }}
        </span>
      </div>
    </div>

    <div class="recipient-fields">

      <!-- NAME FIELD -->
      <div class="section-label">Name</div>
      <div class="form-row-group name-row">
        <div class="recipent-input-margin form-row">              
          <mat-form-field appearance="outline" class="edit-input-field hover-actions field-sm">
            <mat-label>First Name</mat-label>

            <input
              matInput
              type="text"
              [ngModel]="editingIndex === i && editingField === 'firstName' ? tempValue : recipient.firstName?.value"
              (ngModelChange)="tempValue = $event"
              [readonly]="editingIndex !== i || editingField !== 'firstName'"
              placeholder="Click to enter first name"
              (click)="enableEdit(i, 'firstName', recipient.firstName?.value, recipient.role)"
              (keyup.enter)="saveEdit(i, 'firstName', recipient.firstName?.value)"
              (keyup.escape)="cancelEdit()"
            />

            <div matSuffix class="suffix-actions">
              <!-- spinner: shown while this field is saving -->
              <mat-spinner
                *ngIf="isSaving(i, 'firstName')"
                class="action-spinner"
                diameter="16"
                aria-label="Saving">
              </mat-spinner>

              <!-- pencil: only when NOT editing/saving this field, shows on hover -->
              <mat-icon
                *ngIf="!isSaving(i, 'firstName') && (editingIndex !== i || editingField !== 'firstName')"
                class="action-icon edit-icon"
                (click)="enableEdit(i, 'firstName', recipient.firstName?.value, recipient.role)"
                role="button"
                aria-label="Edit">
                edit
              </mat-icon>

              <!-- save/cancel: only while editing this field -->
              <ng-container *ngIf="editingIndex === i && editingField === 'firstName'">
                <mat-icon
                  class="action-icon save-icon"
                  (click)="saveEdit(i, 'firstName', recipient.firstName?.value)"
                  role="button"
                  aria-label="Save">
                  check_circle
                </mat-icon>
                <mat-icon
                  class="action-icon cancel-icon"
                  (click)="cancelEdit()"
                  role="button"
                  aria-label="Cancel">
                  cancel
                </mat-icon>
              </ng-container>
            </div>
          </mat-form-field>  
        </div>
        <div class="recipent-input-margin form-row" *ngIf="!['Manager','Agent'].includes(recipient.role)">
          <mat-form-field appearance="outline" class="edit-input-field hover-actions field-sm">
            <mat-label>Middle Name</mat-label>

            <input
              matInput
              type="text"
              [ngModel]="editingIndex === i && editingField === 'middleName' ? tempValue : recipient.middleName?.value"
              (ngModelChange)="tempValue = $event"
              [readonly]="editingIndex !== i || editingField !== 'middleName'"
              placeholder="Click to enter middle name"
              (click)="enableEdit(i, 'middleName', recipient.middleName?.value, recipient.role)"
              (keyup.enter)="saveEdit(i, 'middleName', recipient.middleName?.value)"
              (keyup.escape)="cancelEdit()"
            />

            <div matSuffix class="suffix-actions">
              <!-- spinner: shown while this field is saving -->
              <mat-spinner
                *ngIf="isSaving(i, 'middleName')"
                class="action-spinner"
                diameter="16"
                aria-label="Saving">
              </mat-spinner>

              <!-- pencil: only when NOT editing/saving this field, shows on hover -->
              <mat-icon
                *ngIf="!isSaving(i, 'middleName') && (editingIndex !== i || editingField !== 'middleName')"
                class="action-icon edit-icon"
                (click)="enableEdit(i, 'middleName', recipient.middleName?.value, recipient.role)"
                role="button"
                aria-label="Edit">
                edit
              </mat-icon>

              <!-- save/cancel: only while editing this field -->
              <ng-container *ngIf="editingIndex === i && editingField === 'middleName'">
                <mat-icon
                  class="action-icon save-icon"
                  (click)="saveEdit(i, 'middleName', recipient.middleName?.value)"
                  role="button"
                  aria-label="Save">
                  check_circle
                </mat-icon>
                <mat-icon
                  class="action-icon cancel-icon"
                  (click)="cancelEdit()"
                  role="button"
                  aria-label="Cancel">
                  cancel
                </mat-icon>
              </ng-container>
            </div>
          </mat-form-field>
        </div>
        <div class="recipent-input-margin form-row" *ngIf="!['Manager','Agent'].includes(recipient.role)">
          <mat-form-field appearance="outline" class="edit-input-field hover-actions field-sm">
            <mat-label>Last Name</mat-label>

            <input
              matInput
              type="text"
              [ngModel]="editingIndex === i && editingField === 'lastName' ? tempValue : recipient.lastName?.value"
              (ngModelChange)="tempValue = $event"
              [readonly]="editingIndex !== i || editingField !== 'lastName'"
              placeholder="Click to enter last name"
              (click)="enableEdit(i, 'lastName', recipient.lastName?.value, recipient.role)"
              (keyup.enter)="saveEdit(i, 'lastName', recipient.lastName?.value)"
              (keyup.escape)="cancelEdit()"
            />

            <div matSuffix class="suffix-actions">
              <!-- spinner: shown while this field is saving -->
              <mat-spinner
                *ngIf="isSaving(i, 'lastName')"
                class="action-spinner"
                diameter="16"
                aria-label="Saving">
              </mat-spinner>

              <!-- pencil: only when NOT editing/saving this field, shows on hover -->
              <mat-icon
                *ngIf="!isSaving(i, 'lastName') && (editingIndex !== i || editingField !== 'lastName')"
                class="action-icon edit-icon"
                (click)="enableEdit(i, 'lastName', recipient.lastName?.value, recipient.role)"
                role="button"
                aria-label="Edit">
                edit
              </mat-icon>

              <!-- save/cancel: only while editing this field -->
              <ng-container *ngIf="editingIndex === i && editingField === 'lastName'">
                <mat-icon
                  class="action-icon save-icon"
                  (click)="saveEdit(i, 'lastName', recipient.lastName?.value)"
                  role="button"
                  aria-label="Save">
                  check_circle
                </mat-icon>
                <mat-icon
                  class="action-icon cancel-icon"
                  (click)="cancelEdit()"
                  role="button"
                  aria-label="Cancel">
                  cancel
                </mat-icon>
              </ng-container>
            </div>
          </mat-form-field>
        </div>
      </div>
      
      <!-- DEILVERY FIELD -->
       
      <div class="delivery-panel">
        <div class="delivery-row">
          <div class="section-label section-label--inline">Delivery method</div>

          <div class="checkbox-container">
            <label *ngFor="let item of recipient.delivery_option | keyvalue" class="mat-mock-checkbox" >
              <input
                type="checkbox"
                [checked]="item.value"
                [disabled]="['Manager','Agent'].includes(recipient.role)"
                (change)="onToggle(i, item.key, $event)">
              <span class="checkmark"></span>
              <span class="label-text">{{ item.key }}</span>
            </label>
          </div>
        </div>
            
        <!-- EMAIL FIELD -->
        <div class="form-row-group contact-row">
          <div class="recipent-input-margin form-row">   
            <mat-form-field appearance="outline" class="edit-input-field hover-actions field-sm">
              <mat-label>Email</mat-label>

              <input
                matInput
                type="email"
                [ngModel]="editingIndex === i && editingField === 'email' ? tempValue : recipient.email?.value"
                (ngModelChange)="tempValue = $event"
                [readonly]="editingIndex !== i || editingField !== 'email'"
                placeholder="Click to enter Email"
                (click)="enableEdit(i, 'email', recipient.email?.value, recipient.role)"
                (keyup.enter)="saveEdit(i, 'email', recipient.email?.value)"
                (keyup.escape)="cancelEdit()"
                #emailInput="ngModel"
                pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
              />

              <div matSuffix class="suffix-actions">
                <!-- spinner: shown while this field is saving -->
                <mat-spinner
                  *ngIf="isSaving(i, 'email')"
                  class="action-spinner"
                  diameter="16"
                  aria-label="Saving">
                </mat-spinner>

                <!-- pencil: only when NOT editing/saving this field, shows on hover -->
                <mat-icon
                  *ngIf="!isSaving(i, 'email') && (editingIndex !== i || editingField !== 'email')"
                  class="action-icon edit-icon"
                  (click)="enableEdit(i, 'email', recipient.email?.value, recipient.role)"
                  role="button"
                  aria-label="Edit">
                  edit
                </mat-icon>

                <!-- save/cancel: only while editing this field -->
                <ng-container *ngIf="editingIndex === i && editingField === 'email'">
                  <mat-icon
                    class="action-icon save-icon"
                    (click)="saveEdit(i, 'email', recipient.email?.value)"
                    role="button"
                    aria-label="Save">
                    check_circle
                  </mat-icon>
                  <mat-icon
                    class="action-icon cancel-icon"
                    (click)="cancelEdit()"
                    role="button"
                    aria-label="Cancel">
                    cancel
                  </mat-icon>
                </ng-container>
              </div>

              <!-- <mat-error *ngIf="emailInput.invalid && emailInput.touched">
                Please enter a valid email address
              </mat-error> -->
            </mat-form-field>
          </div>
          <div *ngIf="!['Manager','Agent'].includes(recipient.role)">         
            <div class="recipent-input-margin form-row">
              <mat-form-field appearance="outline" class="edit-input-field hover-actions field-sm">
                <mat-label>Mobile</mat-label>

                <input
                  matInput
                  type="tel"
                  [ngModel]="editingIndex === i && editingField === 'mobile' ? tempValue : recipient.mobile?.value"
                  (ngModelChange)="tempValue = $event"
                  [readonly]="editingIndex !== i || editingField !== 'mobile'"
                  placeholder="Click to enter Mobile"
                  (click)="enableEdit(i, 'mobile', recipient.mobile?.value, recipient.role)"
                  (keyup.enter)="saveEdit(i, 'mobile', recipient.mobile?.value)"
                  (keyup.escape)="cancelEdit()"
                />

                <div matSuffix class="suffix-actions">
                  <!-- spinner: shown while this field is saving -->
                  <mat-spinner
                    *ngIf="isSaving(i, 'mobile')"
                    class="action-spinner"
                    diameter="16"
                    aria-label="Saving">
                  </mat-spinner>

                  <!-- pencil: only when NOT editing/saving this field, shows on hover -->
                  <mat-icon
                    *ngIf="!isSaving(i, 'mobile') && (editingIndex !== i || editingField !== 'mobile')"
                    class="action-icon edit-icon"
                    (click)="enableEdit(i, 'mobile', recipient.mobile?.value, recipient.role)"
                    role="button"
                    aria-label="Edit">
                    edit
                  </mat-icon>

                  <!-- save/cancel: only while editing this field -->
                  <ng-container *ngIf="editingIndex === i && editingField === 'mobile'">
                    <mat-icon
                      class="action-icon save-icon"
                      (click)="saveEdit(i, 'mobile', recipient.mobile?.value)"
                      role="button"
                      aria-label="Save">
                      check_circle
                    </mat-icon>
                    <mat-icon
                      class="action-icon cancel-icon"
                      (click)="cancelEdit()"
                      role="button"
                      aria-label="Cancel">
                      cancel
                    </mat-icon>
                  </ng-container>
                </div>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Placeholder shown where the item will land during drag -->
    <div class="custom-placeholder" *cdkDragPlaceholder></div>
  </div>
</div>

<!-- <div style="width: 500px;">
{{ recipients | json }}
</div> -->
